import { useEffect, useState } from 'react';

/**
 * New variant, since the old one does not always trigger.
 * We keep the old because we don't want to break other places...
 */
export const useComponentSizeFixed = (ref: React.RefObject<any>) => {
  const [width, setWidth] = useState(ref?.current?.clientWidth);
  const [height, setHeight] = useState(ref?.current?.clientHeight);

  useEffect(() => {
    if (!ref?.current) return;

    const observer = new ResizeObserver(e => {
      if (e[0]) {
        setWidth(e[0].contentRect.width);
        setHeight(e[0].contentRect.height);
      }
    });
    observer.observe(ref?.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return { width, height };
};
